import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonComponent, StrokedButtonComponent } from '../../components';

/**
 * Modal component for delete confirmation
 * Shows a warning message and asks the user to confirm the deletion action
 */
@Component({
  selector: 'ctr-delete-confirmation-modal',
  standalone: true,
  imports: [MatDialogModule, ButtonComponent, StrokedButtonComponent, TranslateModule],
  templateUrl: './delete-confirmation-modal.component.html',
  styleUrl: './delete-confirmation-modal.component.scss',
})
export class DeleteConfirmationModalComponent {
  /**
   * Reference to the dialog for closing it
   */
  private dialogRef = inject(MatDialogRef<DeleteConfirmationModalComponent>);

  /**
   * Confirms the deletion and closes the modal with true
   */
  confirm(): void {
    this.dialogRef.close(true);
  }

  /**
   * Cancels and closes the modal with false
   */
  cancel(): void {
    this.dialogRef.close(false);
  }
}
